<template>
  <div class="deleteDialog">
    <el-dialog
      custom-class="password-dialog"
      title="提示"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
    >
      <div class="deleteDivTwo">
        <el-row class="m-b-16 flex-c">
          <el-col :span="3" :offset="0">当前密码：</el-col>
          <el-col :span="21" :offset="0">
            <el-input
              v-model="oldPassWord"
              placeholder=""
              size="normal"
              clearable
              show-password
              placeholder="请输入当前登录密码"
            ></el-input>
          </el-col>
        </el-row>
        <el-row class="m-b-16 flex-c">
          <el-col :span="3" :offset="0">新的密码：</el-col>
          <el-col :span="21" :offset="0">
            <el-input
              v-model.trim="newPassWord"
              placeholder=""
              size="normal"
              clearable
              show-password
              maxlength="16"
              placeholder="请设置新的登录密码"
            ></el-input>
          </el-col>
        </el-row>
        <el-row class="flex-c">
          <div class="password-tips">
            <img
              class="tips-img"
              src="@/assets/img/views/shudi/tips.png"
              alt=""
            />
            <span>
              新密码长度要求8-16位，且至少包含大写字母、小写字母、数字及特殊符号，避免使用与个人信息相关的内容。</span
            >
          </div>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureClick" v-loading="loading"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      dialogVisible: false,
      oldPassWord: '',
      newPassWord: '',
      loading: false
    };
  },
  props: {},
  methods: {
    sureClick() {
      this.$emit("updatePassWord", {
        password: this.oldPassWord,
        newPassword: this.newPassWord
      });
    },
  },
};
</script>

<style lang="less" scoped>
.password-tips {
  display: flex;
  align-items: center;
  color: #c7c8c8;
  .tips-img {
    width: 16px;
    height: 16px;
    margin-right: 7px;
  }
}
</style>